import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Toastr } from 'data/common';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import Translator from '../../../../translator';

class FHEWysiwyg extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        onChangeEditor: PropTypes.func.isRequired,
        content: PropTypes.string.isRequired,
        disabled: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired,
        error: PropTypes.string,
        markdown: PropTypes.bool
    };

    static defaultProps = {
        error: null,
        markdown: false
    };

    constructor(props) {
        super(props);
        this.state = { editorState: EditorState.createEmpty() };
    }

    componentDidMount() {
        this.loadContent();
    }

    onEditorStateChange = editorState => {
        const { onChangeEditor, markdown } = this.props;
        this.setState({
            editorState
        });
        if (markdown) onChangeEditor(draftToMarkdown(convertToRaw(editorState.getCurrentContent())));
        else onChangeEditor(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    };

    compress(file, callback) {
        const IMG_WIDTH = 300;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
                const scale = IMG_WIDTH / img.width;
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = scale * img.width;
                canvas.height = scale * img.height;
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);

                callback(canvas.toDataURL());
            };
        };
        reader.onerror = () => Toastr.error(Translator.translate('error.message.image_error'));
    }

    _uploadImageCallBack = file => {
        return new Promise((resolve, reject) => this.compress(file, data => resolve({ data: { link: data } })));
    };

    loadContent = () => {
        const { content, markdown } = this.props;

        if (markdown) {
            const editorState = EditorState.createWithContent(convertFromRaw(markdownToDraft(content)));
            this.setState({ editorState });
        } else {
            const contentBlock = htmlToDraft(content);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
                const editorState = EditorState.createWithContent(contentState);
                this.setState({ editorState });
            }
        }
    };

    renderToolbar() {
        const { markdown } = this.props;
        if (markdown)
            return {
                options: ['inline', 'blockType', 'list', 'link', 'emoji', 'remove', 'history'],
                inline: {
                    options: ['bold', 'italic']
                }
            };
        else
            return {
                inline: { inDropdown: true },
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
                image: { uploadCallback: this._uploadImageCallBack, previewImage: true },
                inputAccept:
                    'application/pdf,text/plain,application/vnd.openxmlformatsofficedocument.wordprocessingml.document,application/msword,application/vnd.ms-excel'
            };
    }

    render() {
        const { editorState } = this.state;
        const { classes, title, disabled, error, markdown } = this.props;
        return (
            <div className={classes.container}>
                <div className={error ? classes.errorTitle : classes.title}>{title}</div>
                <Editor
                    markdown={markdown}
                    readOnly={disabled}
                    toolbarHidden={disabled}
                    editorState={editorState}
                    toolbarClassName={classes.toolbar}
                    wrapperClassName={classes.wrapper}
                    editorClassName={classes.editor}
                    onEditorStateChange={this.onEditorStateChange}
                    toolbar={this.renderToolbar()}
                />
                {error && <div className={classes.error}>{error}</div>}
            </div>
        );
    }
}

const styles = theme => ({
    container: {
        width: '100%'
    },
    error: {
        fontSize: '0.75rem',
        marginTop: 8,
        color: 'rgb(203,33,54)'
    },
    errorTitle: {
        fontSize: '0.8em',
        color: 'rgb(203,33,54)',
        marginBottom: 2,
        overflowWrap: 'break-word'
    },
    title: {
        fontSize: '0.8em',
        color: 'rgba(25,25,25, 0.5)',
        marginBottom: 6,
        overflowWrap: 'break-word'
    },
    wrapper: {
        backgroundColor: 'white',
        borderRadius: 8
    },
    editor: {
        margin: '0 10px',
        minHeight: 100
    },
    toolbar: {
        backgroundColor: theme.palette.primary.main
    }
});

export default withStyles(styles, { withTheme: true })(FHEWysiwyg);



// WEBPACK FOOTER //
// ./data/components/FHEWysiwyg.js